export interface TimeBlock {
  id: string;
  day: Date;
  startTime: Date;
  endTime: Date;
  title: string;
}

export interface CalendarProps {
  timeBlocks: TimeBlock[];
  onTimeBlockCreate: (block: TimeBlock) => void;
  onTimeBlockUpdate: (block: TimeBlock) => void;
  onTimeBlockDelete: (id: string) => void;
}

export type ModalType = 'edit' | 'delete-confirm';

export interface DragState {
  isDragging: boolean;
  dragStart: number | null;
  dragEnd: number | null;
  startTime: Date | null;
  endTime: Date | null;
}

export const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];